/**
 * The sound set starts loading in the background on the first gesture of a visit (the
 * AudioContext can only start in one). Menu buttons and links make no sound.
 */
import { preloadSamples } from './samples';

export function installSoundPreload(): void {
  if (typeof document === 'undefined') return;
  const preload = () => preloadSamples();
  document.addEventListener('pointerdown', preload, { capture: true, passive: true });
  document.addEventListener('keydown', preload, { capture: true, passive: true });
}
